import React from "react";

const GlobalContext = React.createContext("globalContext");
export default GlobalContext;



// WEBPACK FOOTER //
// ./src/GlobalContext.js